import { FormHelperText, RadioGroup, styled } from '@mui/material';
import { useEffect, useRef } from 'react';

import { typographyToSystem } from '../../theme/typography';
import { ChkOptionButton } from '../ChkOptionButton/ChkOptionButton';

import { ERROR_TEXT_ID } from './ChkOptionButtonGroup.constants';
import type { ChkOptionButtonGroupProps } from './ChkOptionButtonGroup.types';

export const ChkOptionButtonGroup = ({
  selectedOption,
  setSelectedOption,
  validationError,
  options,
  ariaLabelledby,
}: ChkOptionButtonGroupProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (validationError) {
      ref.current?.focus();
    }
  }, [validationError]);

  const optionsElements = options.map((opt) => (
    <ChkOptionButton
      key={opt.value}
      value={opt.value}
      selected={selectedOption === opt.value}
      label={opt.label}
    />
  ));

  const errorMessage = Boolean(validationError) && (
    <StyledFormErrorText id={ERROR_TEXT_ID} role="alert">
      {validationError}
    </StyledFormErrorText>
  );

  return (
    <>
      <StyledRadioGroup
        value={selectedOption}
        onChange={(e) => setSelectedOption(e.target.value)}
        aria-describedby={validationError ? ERROR_TEXT_ID : undefined}
        aria-labelledby={ariaLabelledby}
        ref={ref}
      >
        {optionsElements}
      </StyledRadioGroup>
      {errorMessage}
    </>
  );
};

const StyledFormErrorText = styled(FormHelperText)(({ theme }) => ({
  margin: theme.spacing(2, 2, 0, 2),
  color: theme.tokens.inputValueHelpError,
  ...typographyToSystem(theme.typography.body3),
}));

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  margin: theme.spacing(5, 0, 0, 0),
}));
